import { clsx } from "clsx";
import type { ReactNode } from "react";
import styles from "./Tag.module.css";

type Size = "small" | "medium" | "large";

// Pre-migration API took `color: NessieThemeColors` (a nessie type) with
// two values used across the codebase: `dt_content_accent` and
// `dt_content_tertiary`. Replaced with a tighter `variant` enum that
// maps directly to DDS content tokens via CSS Module classes.
type Variant = "accent" | "secondary";

type TagProps = {
  size?: Size;
  variant: Variant;
  children: ReactNode;
};

export default function Tag({ size = "small", variant, children }: TagProps) {
  return <div className={clsx(styles.tag, styles[variant], styles[size])}>{children}</div>;
}
